export default __webpack_public_path__ + "static/media/tw.b5ab3e33.svg";